<mmx-history-dialog
  [title]="'Estimate History'"
  [history$]="estimateService.estimateHistory$"
  [loading$]="estimateService.estimateHistoryLoading$"
  [emptyText]="'No estimate history available.'"
  [tz]="tz"
>
  <ng-template let-log>
    <strong>{{ getLogTypeName(log.type) }}</strong> by {{ log.actorName }}.
    <ng-container *ngIf="log.isSendAction()">
      Sent via {{ log.messageData.method }}.
    </ng-container>
  </ng-template>
</mmx-history-dialog>
